<template>
  <div class="grid-x text-left grid-y1">
    <span class="profile">
      Profile
    </span>
    <Panel 
      title="Profile" 
      content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 

      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
      
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod magna aliqua. 

      Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
      
      Consectetur adipiscing elit, sed do eiusmod tempor incidi aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum"
      width="50"
      height="60"
      posX="10"
      posY="10"
    />
  </div>
</template>

<script>
export default {
  name: 'Profile',
  props: {
    msg: String
  },

}
</script>

<style scoped>

</style>
